import React, { useState, useEffect } from "react";
import { Editor } from "react-draft-wysiwyg";
import { convertToRaw, ContentState, EditorState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./FormattedTextEditor.scss";

export const FormattedTextEditor = ({ value, name, setFieldValue, onChange, context }) => {
  const replaceInsTags = (htmlString) => {
    let updatedString = htmlString.replace(/<ins>/g, '<span style="text-decoration: underline">');
    updatedString = updatedString.replace(/<\/ins>/g, '</span>');
    return updatedString;
  };
  const replaceBTags = (htmlString) => {
    let updatedString = htmlString.replace(/<b>/g, '<strong>');
    updatedString = updatedString.replace(/<\/b>/g, '</strong>');
    return updatedString;
  };
  const replaceITags = (htmlString) => {
    let updatedString = htmlString.replace(/<i>/g, '<em>');
    updatedString = updatedString.replace(/<\/i>/g, '</em>');
    return updatedString;
  };

  const prepareDraft = (value) => {
    value = replaceBTags(value);
    value = replaceInsTags(value);
    value = replaceITags(value);
    const draft = htmlToDraft(value);
    const contentState = ContentState.createFromBlockArray(draft.contentBlocks);
    const editorState = EditorState.createWithContent(contentState);
    return editorState;
  };

  const [editorState, setEditorState] = useState(
    value ? prepareDraft(value) : EditorState.createEmpty()
  );

  const onEditorStateChange = (editorState) => {
    const forFormik = draftToHtml(
      convertToRaw(editorState.getCurrentContent())
    );
    setFieldValue(forFormik);
    setEditorState(editorState);
    onChange({ target: { value: forFormik, name: name } });
  };

  useEffect(() => {
    setEditorState(context[name] ? prepareDraft(context[name]) : EditorState.createEmpty());
  }, [context]);

  const toolbar = {
    options: ['link', 'inline', 'list'],
    inline: {
      options: ['bold', 'italic', 'underline']
    },
    list: {
      options: ['unordered', 'ordered']
    },
    link: {
      showOpenOptionOnHover: false,
      defaultTargetOption: '_self',
      options: ['link', 'unlink'],
    }
  };

  return (
    <div>
      <Editor
        toolbar={toolbar}
        editorState={editorState}
        wrapperClassName="custom-wrapper"
        editorClassName="custom-editor"
        onEditorStateChange={onEditorStateChange}
      />
    </div>
  );
};
